import { defaultErrorResponse } from "utils/error";

/**
 * Get all the upcoming meetings created by one user.
 */
export default async function upcomingMeetings(
  userId: string,
): Promise<IResponse> {
  try {
    const response = await fetch(`/api/upcoming/${userId}`, {
      credentials: "same-origin",
      method: "GET",
    });
    if (response.status === 200) {
      const data = await response.json();
      return {
        success: true,
        error: "",
        data: data,
      };
    }
    return defaultErrorResponse(response);
  } catch (e) {
    console.error(e);
    return {
      success: false,
      error: "api-error",
    };
  }
}
